import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Close } from '../../../assets/images/close.svg';

interface CloseButtonProps {
  onClick: () => void;
}

export const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => {
  const { t } = useTranslation('translation');
  return (
    <button
      className={css`
        position: relative;
        z-index: 100;
        width: 44px;
        height: 44px;
        padding: 6px;
        border-radius: 50%;
        transition: background 0.12s;
        :active {
          background: #ece5d4;
        }
      `}
      onClick={onClick}
      aria-label={t('aria_button_close')}
    >
      <Close />
    </button>
  );
};
